<div>
  <div class="mb-3 row" style="margin-top: 0px;">
    <div class="uv-row">
      <span style="padding-top: 7px; margin-right: 10px; font-weight: bold; font-size: 16px;">Selected Switch:</span>
      <span style="padding: 7px 3.5px 0px 3.5px; font-size: 16px; border: none; border-radius: 3px;">
        {{deviceName}}
      </span>
      <span style="width: 30px;">&nbsp;</span>
      <button type="button" pButton label="Select Switch..." [disabled]="!enableSelectDevice"
      (click)="selectDevice()"></button>
    </div>
  </div>
  <div class="mb-3 row" style="margin-top: 30px;">
    <fieldset>
      <legend>Switch Interfaces/Ports</legend>
    </fieldset>
  </div>
  <div class="mb-3 row" style="margin-top: 30px;">

    <p-table #table class="s2j-table" [columns]="cols" [value]="entries" compareSelectionBy="equals"
      [resizableColumns]="true" dataKey="dataKey"
      [scrollable]="true" [scrollHeight]="ifTableHeight"
      [customSort]="true" (sortFunction)="doCustomSort($event)"
      (onFilter)="onFilterChange()" [(first)]="first">

      <ng-template pTemplate="caption">
        <button type="button" pButton icon="fa fa-file-o" iconPos="left" label="Export"
        (click)="table.exportCSV()"></button>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          @for (col of cols; track col) {
            <th pResizableColumn [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          }
        </tr>
        <tr>
          @for (col of cols; track col) {
            <th>
              <input #filter pInputText type="text" style="width: 100%;"
                (input)="table.filter($event.target.value, col.field, col.filterMatchMode)">
              </th>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
          <tr [pSelectableRow]="rowData">
            @for (col of cols; track col) {
              <td>
                <span class="uv-table-value">{{rowData[col.field]}}</span>
              </td>
            }
          </tr>
        </ng-template>

      </p-table>

    </div>
    <div class="mb-3 row" style="margin-bottom: 0px;">
      <div class="uv-row">
        <button [disabled]="!enableRefresh" type="button" pButton label="Refresh"
        icon="fa fa-refresh" (click)="refresh()"></button>
      </div>
    </div>

    <device-selector [header]="'Select a Device'" [(visible)]="displayDeviceSelector" [minDevices]="1" [maxDevices]="1"
      (onCancel)="onDeviceSelectorCancel()" (onOk)="onDeviceSelectorOk($event)">
    </device-selector>

  </div>
